skrilla.directive('dateTime', function (cacheService, moment, dateService) {
  return {
    templateUrl: 'directives/dateTime/dateTime.html',
    scope: {
      value: "<",
      defaultValue: "<",
      simpleDate: "<",
    },
    link: function($scope) {
      $scope.format = $scope.simpleDate ? 'DD-MM-YYYY' : 'DD-MM-YYYY HH:mm:ss Z'

      $scope.$watch('value', function() {
        if ($scope.value) {
          const timezones = dateService.getTimeZones();
          $scope.main = dateService.getTimeZonePreference()
          $scope.others = Object.entries(timezones)
              .filter(([key, value]) => value.offset !== $scope.main.offset)
              .map(([key, value])=> value)
        }
      });
    }
  };
});
